/* eslint-disable no-param-reassign, no-useless-escape, no-unused-vars */
import angular from 'angular';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:table
 * @description
 * # table
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('petDetailTableController', ($http, ENV, $ngRedux, $scope, $rootScope, $timeout) => {
    // init variables
    $scope.petDetailEnableTableActionMenu = false;
    $scope.petDetailInitialLoad = true;
    $scope.petDetailIsPageOptions = false;
    $scope.petDetailIsSortOptions = false;
    $scope.petDetailIsTableActionMenu = false;
    $scope.petDetailPageData = {};
    $scope.petDetailRecords = [];
    $scope.petDetailShowMoreStatus = {};
    $scope.petDetailTableLoading = false;

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.petDetailCheckTableActionsDisplay = () => {
      $scope.petDetailEnableTableActionMenu = false;
      angular.forEach($scope.petDetailTable.actions, (action) => {
        if (!action.superuser || (action.superuser && $rootScope.isSuperUser)) {
          $scope.petDetailEnableTableActionMenu = true;
        }
      });
    };

    $scope.petDetailCheckRangeErrors = async (filter_key, choice_key, date_field, submission) => {
      const choice = $scope.petDetailTable.filters[filter_key].options.choices[choice_key];

      if (!choice.state) {
        choice.from = '';
        choice.to = '';
      } else {
        if (submission) {
          if (!choice.from || !choice.to || choice.from === '' || choice.to === '') {
            choice.error = true;
            return true;
          }
        }

        if (!choice.from || !choice.to || choice.from === '' || choice.to === '') {
          return true;
        }

        let from;
        let to;

        if (date_field) {
          from = moment(choice.from).valueOf();
          to = moment(choice.to).valueOf();
        } else {
          from = choice.from;
          to = choice.to;
        }

        choice.error = to - from < 0;
        return choice.error;
      }
    };

    $scope.pet_detail_watch_timeframe_range = async (filter_key, choice_key, target) => {
      const choice = $scope.petDetailTable.filters[filter_key].options.choices[choice_key];

      if (!choice.state) {
        choice.from = '';
        choice.to = '';
      } else {
        const timeframe = await $scope.format_timeframe_range(choice.from, choice.to);
        choice.from = timeframe[0];
        choice.to = timeframe[1];

        if (choice[target] && choice[target] !== '') {
          await angular.forEach(
            $scope.petDetailTable.filters[filter_key].options.choices,
            async (_, key) => {
              $scope.petDetailTable.filters[filter_key].options.choices[key].state =
                key === choice_key;
            },
          );
        }
      }
    };

    angular.forEach($scope.petDetailTable.filters, async (filter, filter_key) => {
      angular.forEach(filter.options.choices, async (choice, choice_key) => {
        if ('from' in choice) {
          $scope.$watch(
            `table.filters[${filter_key}].options.choices['${choice_key}'].from`,
            async () => {
              if (choice.date_field) {
                await $scope.pet_detail_watch_timeframe_range(filter_key, choice_key, 'from');
              }
              await $scope.petDetailCheckRangeErrors(
                filter_key,
                choice_key,
                choice.date_field,
                false,
              );
            },
          );
        }

        if ('to' in choice) {
          $scope.$watch(
            `table.filters[${filter_key}].options.choices['${choice_key}'].to`,
            async () => {
              if (choice.date_field) {
                await $scope.pet_detail_watch_timeframe_range(filter_key, choice_key, 'to');
              }

              await $scope.petDetailCheckRangeErrors(
                filter_key,
                choice_key,
                choice.date_field,
                false,
              );
            },
          );
        }
      });
    });

    // Angucomplete Filter

    $scope.petDetailFilterAngucomplete = (query, key) => {
      return $scope
        .angucompleteSearch(
          $http,
          ENV,
          $scope.petDetailTable.filters[key].options.search_endpoint,
          $scope.petDetailTable.filters[key].options.search_endpoint_data_key,
          { search: query, autocomplete: true },
        )
        .then((res) => res);
    };

    $scope.petDetailFilterAngucompletePage = (query, key) => {
      return $scope
        .angucompleteSearchByUrl(
          $http,
          query,
          $scope.petDetailTable.filters[key].options.search_endpoint_data_key,
        )
        .then((res) => res);
    };

    $scope.petDetailSetSelectedAngucomplete = (item, key) => {
      $scope.petDetailTable.filters[key].options.selected.push(item);
    };

    $scope.petDetailRemoveAngucomplete = (id, key) => {
      $scope.petDetailTable.filters[key].options.selected = $scope.petDetailTable.filters[
        key
      ].options.selected.filter((item) => item.id !== id);
    };

    $scope.petDetailRemoveAllAngucomplete = (key) => {
      $scope.petDetailTable.filters[key].options.selected = [];
    };

    $scope.pet_detail_change_timeframe = async (new_timeframe_choice) => {
      await angular.forEach($scope.petDetailTable.filters, async (filter, filter_key) => {
        if (filter.options.query_string_parameter === 'timeframe') {
          await angular.forEach(filter.options.choices, async (choice, choice_key) => {
            $scope.petDetailTable.filters[filter_key].options.choices[choice_key].state =
              choice.value === new_timeframe_choice;
          });
        }
      });
    };

    // Get Table Data

    $rootScope.getPetDetail = async () => {
      $scope.petDetailTableLoading = true;
      const parameters = { ...$scope.petDetailTable.options.default_parameters };

      $scope.petDetailPageData = {};
      $scope.petDetailRecords = [];

      await angular.forEach($scope.petDetailTable.filters, async (filter, key) => {
        if (filter.type === 'multiple_choice') {
          parameters[filter.options.query_string_parameter] = Object.values(filter.options.choices)
            .filter((item) => item.state === true)
            .map((item) => item.value)
            .join(',');

          if (
            (!(filter.options.query_string_parameter in parameters) ||
              parameters[filter.options.query_string_parameter] === '') &&
            'no_selected_parameter' in filter.options
          ) {
            parameters[filter.options.query_string_parameter] =
              filter.options.no_selected_parameter;
          }
        }

        if (filter.type === 'multi_level_multiple_choice') {
          const multi_level_selected = [];

          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if (choice.state === true) {
              if ('options' in choice) {
                let options = '';

                await angular.forEach(choice.options, async (level, level_key) => {
                  if (level.state) {
                    options = `${options}:${level.value}`;
                  }
                });

                if (options !== '') {
                  multi_level_selected.push(`${choice.value}${options}`);
                }
              }
            }
          });

          if (multi_level_selected.length) {
            parameters[filter.options.query_string_parameter] = multi_level_selected.join(',');
          }
        }

        if (filter.type === 'single_choice') {
          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if ('error' in $scope.petDetailTable.filters[key].options.choices[choice_key]) {
              $scope.petDetailTable.filters[key].options.choices[choice_key].error = false;
            }

            if (choice.state === true) {
              if (choice.type === 'standard') {
                parameters[filter.options.query_string_parameter] = choice.value;
              } else if (choice.type === 'amount') {
                if (!choice.amount || choice.amount === '') {
                  $scope.petDetailTable.filters[key].options.choices[choice_key].error = true;
                } else {
                  parameters[
                    filter.options.query_string_parameter
                  ] = `${choice.value}:${choice.amount}`;
                }
              } else if (choice.type === 'range') {
                if (choice.date_field) {
                  const formatted_dates = await $scope.format_timeframe_range(
                    choice.from,
                    choice.to,
                  );

                  let date = null;

                  if (formatted_dates[0] && formatted_dates[0] !== '') {
                    date = moment(formatted_dates[0]);
                    $scope.petDetailTable.filters[key].options.choices[
                      choice_key
                    ].to = date.isValid() ? date.format('YYYY-MM-DD') : null;
                  }

                  if (formatted_dates[1] && formatted_dates[1] !== '') {
                    date = moment(formatted_dates[1]);
                    $scope.petDetailTable.filters[key].options.choices[
                      choice_key
                    ].to = date.isValid() ? date.format('YYYY-MM-DD') : null;
                  }

                  if (
                    $scope.petDetailTable.filters[key].options.choices[choice_key].from &&
                    $scope.petDetailTable.filters[key].options.choices[choice_key].to
                  ) {
                    const hasErrors = await $scope.petDetailCheckRangeErrors(
                      key,
                      choice_key,
                      choice.date_field,
                      true,
                    );

                    if (!hasErrors) {
                      parameters[
                        filter.options.query_string_parameter
                      ] = `range:${choice.from}:${choice.to}`;
                    }
                  } else {
                    $scope.petDetailTable.filters[key].options.choices[choice_key].error = true;
                  }
                } else if (choice.to && choice.from) {
                  const hasErrors = await $scope.petDetailCheckRangeErrors(
                    key,
                    choice_key,
                    choice.date_field,
                    true,
                  );

                  if (!hasErrors) {
                    parameters[
                      filter.options.query_string_parameter
                    ] = `${choice.value}:${choice.from}:${choice.to}`;
                  }
                } else {
                  $scope.petDetailTable.filters[key].options.choices[choice_key].error = true;
                }
              }
            }
          });
        }
        if (filter.type === 'angucomplete' && 'search_endpoint' in filter.options) {
          if (filter.options.selected.length) {
            parameters[filter.options.query_string_parameter] = filter.options.selected
              .map((item) => item.id)
              .join(',');
          }
        }
      });

      let error = false;

      await angular.forEach($scope.petDetailTable.filters, async (filter, key) => {
        if (filter.type === 'single_choice') {
          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if (
              'error' in $scope.petDetailTable.filters[key].options.choices[choice_key] &&
              $scope.petDetailTable.filters[key].options.choices[choice_key].error
            ) {
              error = true;
            }
          });
        }
      });

      if (error) {
        return;
      }

      const sortOptions = [];

      await Object.entries($scope.petDetailTable.sort_options).forEach(([key, item]) => {
        if (item.state === true) {
          sortOptions.push(item.value === '1' ? key : `-${key}`);
        }
      });

      parameters.order = sortOptions.join(',');
      parameters.page_size = $scope.petDetailTable.options.records_per_page;

      $scope
        .getTableData(
          $http,
          ENV,
          $scope.petDetailTable.options.endpoint,
          $scope.petDetailTable.options.endpoint_data_key,
          parameters,
        )
        .then((res) => {
          $timeout(async () => {
            if ($scope.petDetailTable.options.scale_up) {
              if (
                res.meta.count === 0 &&
                'timeframe' in parameters &&
                parameters.timeframe !== 'all' &&
                $scope.petDetailInitialLoad
              ) {
                if (parameters.timeframe === 'day') {
                  await $scope.pet_detail_change_timeframe('week');
                } else if (parameters.timeframe === 'week') {
                  await $scope.pet_detail_change_timeframe('year');
                } else if (parameters.timeframe === 'year') {
                  await $scope.pet_detail_change_timeframe('all');
                }

                return $rootScope.getPetDetail();
              }
            }

            $scope.petDetailTableLoading = false;
            $scope.petDetailPageData = res;
            $scope.petDetailInitialLoad = false;
            $scope.petDetailShowMoreStatus = {};
            $scope.petDetailScrollToTop();
          });
        });
    };

    $scope.goToPetDetailPage = (url) => {
      $scope.petDetailTableLoading = true;
      $scope.petDetailPageData = {};
      $scope.petDetailRecords = [];

      $scope
        .getTableDataByUrl($http, url, $scope.petDetailTable.options.endpoint_data_key)
        .then((res) => {
          $timeout(() => {
            $scope.petDetailPageData = res;
            $scope.petDetailTableLoading = false;
            $scope.petDetailScrollToTop();
          });
        });
    };

    $scope.petDetailValidCustomValue = (filter_key, choice_key, key) => {
      const choice = $scope.petDetailTable.filters[filter_key].options.choices[choice_key];

      if (key === 'amount') {
        choice.amount = choice.amount.replace(/[^0-9\-]+/g, '');

        if (choice.amount === '' || choice.amount === null) {
          return;
        }
      }

      if (key === 'range') {
        choice.from = choice.from.replace(/[^0-9\-]+/g, '');
        choice.to = choice.to.replace(/[^0-9\-]+/g, '');
      }
    };

    $scope.petDetailClearText = async (filter_key, choice_key) => {
      await angular.forEach(
        $scope.petDetailTable.filters[filter_key].options.choices,
        async (choice, key) => {
          if (key === choice_key) {
            choice.state = true;
          } else {
            choice.state = false;
            if ('error' in choice) {
              choice.error = false;
            }
            if ('amount' in choice) {
              choice.amount = '';
            }
            if ('from' in choice || 'to' in choice) {
              $scope.petDetailCheckRangeErrors(filter_key, key, choice.date_field, false);
            }
          }
        },
      );
    };

    $scope.petDetailSwitchSelectAll = (key, value) => {
      Object.values($scope.petDetailTable.filters[key].options.choices).forEach((item) => {
        item.state = value;
        if ('options' in item) {
          Object.values(item.options).forEach((option) => {
            option.state = value;
          });
        }
      });
    };

    $scope.petDetailShowPageOptions = () => {
      $scope.petDetailIsPageOptions = !$scope.petDetailIsPageOptions;
    };

    $scope.petDetailSelectPageOption = (option) => {
      $scope.petDetailTable.options.records_per_page = option;
    };

    $scope.petDetailShowSortOptions = () => {
      $scope.petDetailIsSortOptions = !$scope.petDetailIsSortOptions;
    };

    $scope.petDetailSelectSort = async (option_key, value) => {
      await angular.forEach($scope.petDetailTable.sort_options, async (option, key) => {
        if (key === option_key) {
          option.value = value;
          option.state = true;
        }
      });
    };

    $scope.petDetailSelectSortOptions = () => {
      $scope.petDetailIsSortOptions = false;
    };

    $scope.petDetailShowSortTitles = () => {
      return Object.values($scope.petDetailTable.sort_options)
        .filter((item) => item.state === true)
        .map((item) => item.title)
        .join(', ');
    };

    $scope.petDetailGetChoices = async () => {
      await Promise.all(
        $scope.petDetailTable.filters.map(async (value, key) => {
          if (
            (value.type === 'multiple_choice' || value.type === 'multi_level_multiple_choice') &&
            'choices_endpoint' in value.options
          ) {
            const choices = await $scope.getTableFilterOptions(
              $http,
              ENV,
              value.options.choices_endpoint,
              value.options.choices_endpoint_data_key,
            );
            if (choices && !!choices.length) {
              await choices.forEach((item) => {
                const state =
                  ('default_choice' in value.options &&
                    item[value.options.name_attribute] === value.options.default_choice) ||
                  !('default_choice' in value.options);

                $scope.petDetailTable.filters[key].options.choices[
                  item[value.options.name_attribute]
                ] = {
                  state,
                  value: item.id,
                };

                if ('level' in value.options && value.options.level) {
                  $scope.petDetailTable.filters[key].options.choices[
                    item[value.options.name_attribute]
                  ].options = angular.copy(value.options.level);
                }
              });
            }
          }
        }),
      );

      $rootScope.getPetDetail();
    };

    $scope.petDetailGetRedemptionDetail = (index, redemption_id) => {
      $scope
        .getTableData($http, ENV, `/2.0/redemptions/${redemption_id}/`, 'redemptions', {})
        .then((res) => {
          $timeout(async () => {
            $scope.petDetailPageData[$scope.petDetailTable.options.endpoint_data_key][
              index
            ].redemption = res.redemptions;
            $scope.petDetailPageData[$scope.petDetailTable.options.endpoint_data_key][
              index
            ].redemption.reward = res.redemptions.reward.description;
          });
        });
    };

    $scope.petDetailGetTransactionDetail = (index, transaction_id) => {
      $scope
        .getTableData($http, ENV, `/2.0/transactions/${transaction_id}/`, 'transactions', {})
        .then((res) => {
          $timeout(async () => {
            $scope.petDetailPageData[$scope.petDetailTable.options.endpoint_data_key][
              index
            ].transaction = res.transaction;
          });
        });
    };

    $scope.petDetailShowMore = (index) => {
      $scope.petDetailShowMoreStatus[index] = !$scope.petDetailShowMoreStatus[index];

      const option =
        $scope.petDetailPageData[$scope.petDetailTable.options.endpoint_data_key][index];

      if ($scope.petDetailTable.options.row_style === 'redemption' && !('redemption' in option)) {
        $scope.petDetailGetRedemptionDetail(index, option.id);
      } else if (
        $scope.petDetailTable.options.row_style === 'activity' &&
        !('redemption' in option) &&
        !('transaction' in option)
      ) {
        if (option.activity_type.includes('Redemption')) {
          $scope.petDetailGetRedemptionDetail(index, option.redemption_id);
        } else if (option.activity_type.includes('Transaction')) {
          $scope.petDetailGetTransactionDetail(index, option.transaction_id);
        }
      }
    };

    $scope.petDetailShowTableActionMenu = () => {
      $scope.petDetailIsTableActionMenu = !$scope.petDetailIsTableActionMenu;
    };

    $scope.petDetailScrollToTop = () => {
      $('pet-detail-table .container').scrollTop(0);
      $('pet-detail-table .filter-panel').scrollTop(0);
    };

    $(document).on('click', (event) => {
      const pageOptionEle = $('pet-detail-table .page-content');
      const sortOptionEle = $('pet-detail-table .sort-content');
      const tableActionsEle = $('pet-detail-table .table-actions-options');

      const $target = $(event.target);

      if (
        pageOptionEle !== event.target &&
        !$target.closest('pet-detail-table .page-content').length &&
        !pageOptionEle.has(event.target).length
      ) {
        $timeout(() => {
          $scope.petDetailIsPageOptions = false;
        });
      }
      if (
        sortOptionEle !== event.target &&
        !$target.closest('pet-detail-table .sort-content').length &&
        !sortOptionEle.has(event.target).length &&
        $scope.petDetailIsSortOptions
      ) {
        $timeout(() => {
          $scope.petDetailIsSortOptions = false;
          $scope.petDetailSelectSortOptions();
        });
      }
      if (
        tableActionsEle !== event.target &&
        !$target.closest('pet-detail-table .table-actions-options').length &&
        !tableActionsEle.has(event.target).length &&
        $scope.petDetailIsTableActionMenu
      ) {
        $timeout(() => {
          $scope.petDetailIsTableActionMenu = false;
        });
      }
    });

    $scope.generateActivityPetDetailLink = (petId) => {
      return `${$rootScope.routes['user-activity']}/pet-detail/${petId}`;
    };

    $scope.init();

    const petDetailComponentVisibleListener = $rootScope.$watch('componentOpened', () => {
      if (!$rootScope.componentOpened) {
        $scope.petDetailEnableTableActionMenu = false;
        $scope.petDetailInitialLoad = true;
        $scope.petDetailIsPageOptions = false;
        $scope.petDetailIsSortOptions = false;
        $scope.petDetailIsTableActionMenu = false;
        $scope.petDetailPageData = {};
        $scope.petDetailRecords = [];
        $scope.petDetailShowMoreStatus = {};
        $scope.clearPetDetail();
      }
    });

    const petIdListener = $rootScope.$watch('adminPet', () => {
      if ($rootScope.adminPet) {
        $scope.setTable();
        $scope.petDetailEnableTableActionMenu = false;
        $scope.petDetailInitialLoad = true;
        $scope.petDetailIsPageOptions = false;
        $scope.petDetailIsSortOptions = false;
        $scope.petDetailIsTableActionMenu = false;
        $scope.petDetailPageData = {};
        $scope.petDetailRecords = [];
        $scope.petDetailShowMoreStatus = {};
        $scope.petDetailCheckTableActionsDisplay();
        $scope.petDetailGetChoices();
        $scope.petDetailScrollToTop();
      } else {
        $scope.petDetailEnableTableActionMenu = false;
        $scope.petDetailInitialLoad = true;
        $scope.petDetailIsPageOptions = false;
        $scope.petDetailIsSortOptions = false;
        $scope.petDetailIsTableActionMenu = false;
        $scope.petDetailPageData = {};
        $scope.petDetailRecords = [];
        $scope.petDetailShowMoreStatus = {};
        $scope.clearPetDetail();
      }
    });

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      petIdListener();
      petDetailComponentVisibleListener();
    });
  })
  .directive('petDetailTable', () => {
    return {
      templateUrl: 'templates/v2/pet-detail-table.html',
    };
  });
